import { Box, CircularProgress, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { LOGIN_PATH } from '../config/paths';
import { useSession } from '../context/use-session';

const SignOutPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { logout } = useSession();

  useEffect(() => {
    const performLogout = async () => {
      logout();
      navigate(LOGIN_PATH);
    };
    performLogout();
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 3,
      }}
    >
      <CircularProgress color="primary" />
      <Typography
        variant="body1"
        sx={{
          color: 'text.secondary',
        }}
      >
        {t('SIGNING_OUT')}
      </Typography>
    </Box>
  );
};

export default SignOutPage;
